import { GROUP, GROUP_AGENDA, EVENT_GROUPS } from 'queries/group';
import { makeApolloClient, logError } from '../util';
import { fetchAgenda } from './agenda.actions';
import {
	FETCH_GROUP,
	FETCH_EVENT_GROUPS,
	CLEAR_GROUP,
	CLEAR_GROUPS,
	CREATE_OR_DUPLICATE_GROUP,
	UPDATE_GROUP,
	DELETE_GROUP,
	ADD_ATTENDEES_TO_GROUP,
	REMOVE_ATTENDEES_FROM_GROUP,
} from './actionTypes';

const setEventGroups = (groups, from) => ({
	type: FETCH_EVENT_GROUPS,
	groups,
	from,
});

const setGroup = (group, from) => ({
	type: FETCH_GROUP,
	group,
	from,
});

export const clearGroup = from => ({
	type: CLEAR_GROUP,
	from,
});

export const clearGroups = from => ({
	type: CLEAR_GROUPS,
	from,
});

export const addGroup = (group, from) => ({
	type: CREATE_OR_DUPLICATE_GROUP,
	from,
	group,
});

export const updateGroup = (group, from) => ({
	type: UPDATE_GROUP,
	from,
	group,
});

export const deleteGroup = (groupID, from) => ({
	type: DELETE_GROUP,
	from,
	groupID,
});

export const addAttendeesToGroup = (attendeeIDs, from) => ({
	type: ADD_ATTENDEES_TO_GROUP,
	from,
	attendeeIDs,
});

export const removeAttendeesFromGroup = (attendeeIDs, from) => ({
	type: REMOVE_ATTENDEES_FROM_GROUP,
	from,
	attendeeIDs,
});

export const thunkFetchEventGroups = (eventID, searchTerm, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventGroups } = await client.request(EVENT_GROUPS, {
			event_id: eventID,
			search_term: searchTerm,
		});
		dispatch(setEventGroups(eventGroups, from));
		return eventGroups;
	} catch (error) {
		logError('groups.actions.thunkFetchEventGroups', error);
	}
};
export const thunkFetchGroupAgenda = (eventID, groupID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { groupAgenda } = await client.request(GROUP_AGENDA, {
			event_id: eventID,
			group_id: groupID,
		});
		// maybe type from agenda reducer
		dispatch(fetchAgenda(groupAgenda, from));
	} catch (error) {
		logError('groups.actions.thunkFetchGroupAgenda', error);
	}
};

export const thunkFetchGroup = (groupID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { group } = await client.request(GROUP, {
			id: groupID,
		});
		dispatch(setGroup(group, from));
	} catch (error) {
		logError('groups.actions.thunkFetchGroup', error);
	}
};
